import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './scss/_flsLandingPage.scss';

const CHANNEL_LOGOS = [
  { name: 'Kazoom', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/kozoom-212.png', id: '1992' },
  { name: 'World Surf League', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/wsl-212-v2.png', id: '1998' },
  // { name: 'Skate Surf Snow', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/skate-212.png', id: '1996' },
  { name: 'Red Bull TV', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/red-bull-212.png', id: '1988' },
  { name: 'Adventure Zone', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/adventure-zone-212.png', id: '1991' },
  { name: 'Extreme TV', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/extreme-212.png', id: '1993' },
  { name: 'Surf Cinema', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/surfcin-212.png', id: '1997' },
  { name: 'Absinthe TV', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/absynthe-212.png', id: '1990' },
  { name: 'FUEL TV', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/fueltv.png', id: '1989' },
  { name: 'World Of Freesports', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/wof.png', id: '1994' },
  { name: 'InTrouble', logo: 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/action-extreme-sports/introuble-212.png', id: '1995' },
];

const FAQS_LIST = [
  {
    question: 'What is Free Live Sports TV?',
    answer: 'Free Live Sports TV is the ultimate destination for sports fans, offering over 100 live sports channels, plus 500+ free sports movies and thousands of hours of on-demand content including highlights, analysis, and documentaries.',
  },
  {
    question: 'Is it really 100% free to watch?',
    answer: 'Yes! Free Live Sports TV is 100% free forever. No sign-ups, no subscription fees, no trial periods, and no credit card required—just instant access to live sports.',
  },
  {
    question: 'Is it 100% legal to stream?',
    answer: 'Yes. All channel broadcasts and video-on-demand programs streamed on Free Live Sports TV are 100% legal and licensed directly from official broadcast partners and sports federations.',
  },
  {
    question: 'What type of channels can I watch on Free Live Sports TV?',
    answer: 'You can watch Action Sports, Extreme Sports, Surfing, Skateboarding, Snowboarding, Basketball, Billiards, American Football, Horseback Riding, Baseball, Lacrosse, MMA, Motorsport, Poker, and many specialized sports channels.',
  },
  {
    question: 'How can I watch on my mobile or TV device?',
    answer: 'You can watch on PC/Laptop via web browser, download our app on iOS App Store and Google Play Store for mobile/tablet, or get our app on Apple TV, Amazon Fire TV, Roku, VIZIO TV, and Android TV.',
  },
];

const FlsLandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openFaqIndex, setOpenFaqIndex] = useState(0);
  const carouselRef = useRef(null);

  const scrollToTarget = (targetId) => {
    const element = document.getElementById(targetId);
    if (element) {
      const headerOffset = window.innerWidth <= 768 ? 70 : 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: Math.max(0, offsetPosition),
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    document.title = 'Free Live Sports Streaming | Watch Sports Online Anytime - FLS';

    if (location.hash) {
      const rawHash = location.hash.replace('#', '');
      let targetId = rawHash;
      if (rawHash === 'web') targetId = 'ways-to-watch';
      if (rawHash === 'mobile') targetId = 'watch-on-mobile';
      if (rawHash === 'tv') targetId = 'watch-on-tv';
      if (rawHash === 'faq') targetId = 'faqs';

      setTimeout(() => {
        scrollToTarget(targetId);
      }, 150);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const scrollToId = (id) => {
    scrollToTarget(id);
  };

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const handleWatchOnline = () => {
    navigate('/live-channels');
  };

  const scrollCarousel = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      carouselRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="flsLandingContainer">
      {/* 1. Hero Block */}
      <section className="flsHeroBlock">
        <div className="heroContainer">
          <div className="heroLeft">
            <h1 className="heroTitle">Watch FREE LIVE SPORTS</h1>
            <p className="heroDesc">
              Welcome to the ultimate destination for sports fans, all 100% free! Stream over 100 live sports TV channels, plus enjoy endless hours of on-demand content – from game highlights and in-depth analysis to must-watch sports documentaries. Catch your favorite sports, leagues, teams, and players with daily live games and events, all at your fingertips.
            </p>
            <h3 className="heroSubtitle">Score Big, Pay Nothing</h3>
            <button className="ctaBtn" onClick={handleWatchOnline}>
              WATCH ONLINE ▶
            </button>
          </div>

          <div className="heroRight">
            <div className="heroMockupWrapper">
              <img
                src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/fls-laptop-v3-1024x610.png"
                alt="Free Live Sports Devices"
                className="heroMockupImg"
                onError={(e) => {
                  e.target.src = 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/fls-hero-devices-v2.png';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* 3. Section: "Free Live Sports? NO LOGIN" */}
      <section className="flsNoCostsBlock">
        <div className="noCostsBgOverlay"></div>
        <div className="noCostsContainer">
          <div className="noCostsHeader">
            <h2 className="noCostsTitle">Free Live Sports?</h2>
            <h3 className="noCostsBigText">NO LOGIN</h3>
          </div>

          <div className="featuresCard">
            <h3 className="cardHeader">FREE FOREVER</h3>
            <ul className="featuresList">
              <li><span className="checkMark">✓</span> 100+ Live Channels Streaming 24/7</li>
              <li><span className="checkMark">✓</span> 100% Free & Always Free</li>
              <li><span className="checkMark">✓</span> 500+ Free Sports Movies & Content</li>
              <li><span className="checkMark">✓</span> 100% Legal, 100% Free</li>
              <li><span className="checkMark">✓</span> No credit card or registration needed</li>
              <li><span className="checkMark">✓</span> Thousands of hours of games on demand</li>
              <li><span className="checkMark">✓</span> Stream Big Events & Tournaments Free</li>
            </ul>
          </div>
        </div>
      </section>

      {/* 4. Section: "Discover Something New" Carousel */}
      <section className="flsDiscoverBlock">
        <div className="discoverContainer">
          <h2 className="discoverTitle">Discover Something New</h2>
          <p className="discoverSubtitle">
            Explore 100+ channels and become the ultimate sports fan.
          </p>

          <div className="carouselWrapper">
            <button className="carouselArrow leftArrow" onClick={() => scrollCarousel('left')}>
              ❮
            </button>
            <div className="channelsGrid" ref={carouselRef}>
              {CHANNEL_LOGOS.map((ch, idx) => (
                <div
                  key={idx}
                  className="channelLogoCard"
                  onClick={() => navigate(`/live-channels?c=${ch.id}`)}
                >
                  <img src={ch.logo} alt={ch.name} className="chLogoImg" />
                </div>
              ))}
            </div>
            <button className="carouselArrow rightArrow" onClick={() => scrollCarousel('right')}>
              ❯
            </button>
          </div>

          <button className="ctaBtn" onClick={() => navigate('/channels')}>
            JOIN ALL CHANNELS ▶
          </button>
        </div>
      </section>

      {/* 5. Section: Watch online on PC or Laptop (id="ways-to-watch") */}
      <section id="ways-to-watch" className="flsDeviceSection webSection">
        <div className="sectionInner">
          <div className="sectionTextCol">
            <h2 className="deviceHeading">Watch online<br />on PC or Laptop</h2>
            <p className="deviceDesc">Watch all channels by visiting live-channels on web browsers.</p>
            <button className="ctaBtn" onClick={handleWatchOnline}>
              WATCH ONLINE ▶
            </button>
          </div>

          <div className="sectionImgCol">
            <div className="deviceMockup">
              <img
                src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/fls-laptop-v3-1024x610.png"
                alt="Watch online on PC or Laptop"
                className="deviceImg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Black Brush / Jagged Section Divider */}
      <div className="jaggedDivider">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="jaggedSvg">
          <path d="M0,0 L0,30 Q150,110 300,20 Q450,-30 600,70 Q750,110 900,30 Q1050,-20 1200,60 L1200,120 L0,120 Z" fill="#000000"></path>
        </svg>
      </div>

      {/* 6. Section: Watch on Mobile / Tablet (id="watch-on-mobile") */}
      <section id="watch-on-mobile" className="flsDeviceSection mobileSection">
        <div className="sectionInner reverse">
          <div className="sectionImgCol">
            <div className="mobileMockupWrapper">
              <img
                src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/fls-mobile-ui-v4.png"
                alt="Watch on Mobile"
                className="mobileUiImg"
                onError={(e) => {
                  e.target.src = 'https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/search_teaser_logo.png';
                }}
              />
            </div>
          </div>

          <div className="sectionTextCol">
            <h2 className="deviceHeading">Watch on<br />Mobile / Tablet</h2>
            <p className="deviceDesc">Stream all channels on your mobile or tablet device.</p>
            <div className="appBadgesRow">
              <a
                href="https://apps.apple.com/us/app/fls-live-sports-streaming/id6740391839"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/apple-store-sml.png"
                  alt="Apple App Store"
                  className="appStoreBadgeImg"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=tv.sportsstudio.fls"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/google-play-sml.png"
                  alt="Google Play"
                  className="appStoreBadgeImg"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Black Brush / Jagged Section Divider */}
      <div className="jaggedDivider">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="jaggedSvg">
          <path d="M0,20 Q200,120 400,10 Q600,-20 800,90 Q1000,120 1200,30 L1200,120 L0,120 Z" fill="#000000"></path>
        </svg>
      </div>

      {/* 7. Section: Watch on TV (id="watch-on-tv") */}
      <section id="watch-on-tv" className="flsDeviceSection tvSection">
        <div className="sectionInner">
          <div className="sectionTextCol">
            <h2 className="deviceHeading">Watch on TV</h2>
            <p className="deviceDesc">
              Search the Smart TV app stores to download.<br />
              Video is available on key TV platforms:
            </p>
            <div className="tvPlatformsGrid">
              <div className="tvRow">
                <a
                  href="https://apps.apple.com/us/app/fls-live-sports/id6740391839?platform=appleTV"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/apple-tv-logo-v2-r0qtme24pvmsd6c27qkk1maxjvulybktooh4xaslpm.png" alt="Apple TV" className="tvBadgeImg" />
                </a>
                <a
                  href="https://www.amazon.com/dp/B0DGZJX19J/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/fire-tv-v3-quhr08xbp6cb6eco4u8tz4c13x5fm51v4pxf96lv56.png" alt="Fire TV" className="tvBadgeImg" />
                </a>
              </div>
              <div className="tvRow">
                <a
                  href="https://channelstore.roku.com/details/7d4e6767c8208252c2ae98bd621003b9:8504e1b57eb77637c42368ebc7a07e21/free-live-sports"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/roku-v3-quhr08xbp6cb6eco4u8tz4c13x5fm51v4pxf96lv56.png" alt="Roku" className="tvBadgeImg" />
                </a>
                <a
                  href="https://www.vizio.com/en/smart-tv-apps?appName=freelivesports&appId=vizio.freelivesports"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/vizio-tv-logo-r1pccx3299b0a34jmpo9ai9zxjc5udfobu4a92j5yi.png" alt="VIZIO" className="tvBadgeImg" />
                </a>
              </div>
              <div className="tvRow">
                <a
                  href="https://play.google.com/store/apps/details?id=tv.sportsstudio.fls"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/android-tv-logo-r23lu74i469bo886l2rcpt8binr1euplth05vq83qi.png" alt="Android TV" className="tvBadgeImg" />
                </a>
              </div>
            </div>
          </div>

          <div className="sectionImgCol">
            <div className="deviceMockup">
              <img
                src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/fls-ui-tv.jpg"
                alt="Watch on TV"
                className="deviceImg"
                onError={(e) => {
                  console.log("ERROR");
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* 8. "New Devices Coming Soon" Block */}
      <section className="flsComingSoonBlock">
        <div className="comingSoonInner">
          <h2 className="comingSoonTitle">New Devices Coming Soon</h2>
          <p className="comingSoonDesc">
            FreeLiveSports is working hard to support all your favourite devices.
          </p>
          <div className="devicesMontageImgWrapper">
            <img
              src="https://gizmeon.mdc.akamaized.net/files/web/images/fls/static/dev-montage-v2-1024x562.png"
              alt="New Devices Coming Soon Montage"
              className="devicesMontageImg"
              onError={(e) => {
                console.log("ERROR");
              }}
            />
          </div>
        </div>
      </section>

      {/* 9. FAQs Section (id="faqs") */}
      <section id="faqs" className="flsFaqsBlock">
        <div className="faqsInner">
          <h2 className="faqsTitle">FAQs</h2>
          <div className="accordionWrapper">
            {FAQS_LIST.map((faq, idx) => {
              const isOpen = openFaqIndex === idx;
              return (
                <div key={idx} className={`faqItem ${isOpen ? 'open' : ''}`}>
                  <div className="faqHeader" onClick={() => toggleFaq(idx)}>
                    <span className="faqQuestion">{faq.question}</span>
                    <span className="faqToggleIcon">{isOpen ? '▼' : '▶'}</span>
                  </div>
                  {isOpen && (
                    <div className="faqBody">
                      <p className="faqAnswer">{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FlsLandingPage;
